<template>
    <div class="m-click-tip click-tip">
        <div class="click-tip__text-container">
            <h3 class="click-tip__text" v-html="$t('ui.mobile.welcome-message')"></h3>
        </div>
        <svg-icon
            original
            name="icons/hand"
            class="click-tip__hand-icon"
        />
    </div>
</template>

<script>
export default {
    name: 'MClickTip'
}
</script>

<style lang="scss">
@import "m-click-tip";
</style>
